import type { BasePoi, User } from "./base.types";
import type { PoiCoupon } from "./coupon.types";

export interface UserRating {
  id: number;
  review: string;
  rating: number;
  createdDate: string;
  user: User;
  poiId: number;
}

export interface LastWatering {
  id: number;
  createdAt: string;
  poiId: number;
  userId: number;
  amount: number;
  condition: string;
  description: string;
}

export enum PlantStatus {
  HYDRATED,
  THIRSTY,
  PARCHED,
}

export interface PlantDetail {
  id: number;
  poiId: number;
  plantId: string;
  species: string;
  thirstAmount: number;
  waterableStatus: PlantStatus;
}

export interface PoiItem extends BasePoi {
  id: string;
  openingHours?: string;
  shortDescription?: string;
  longDescription?: string;
  contact?: any;
  website?: string;
  socialLinks: Record<string, string>;
  mainService: string;
  tags: string[]; // Required for search
  verified: "VERIFIED" | "UNVERIFIED" | "PENDING";
  hasCoupon: boolean;
  waterableStatus?: PlantStatus;
}

export interface PoiDetail extends BasePoi {
  id: number;
  tags: string[]; // Required for detail
  rating: number;
  ratingNumber: number;
  mainService: string;
  longDescription: string;
  contactPersonPhone: string;
  website: string;
  facebook: string;
  instagram: string;
  tiktok: string;
  email: string;
  openingHours: string;
  eventStartDate: string;
  eventEndDate: string;
  partnerId: number;
  enabled: boolean;
  verified: string;
  bio: string;
  imageUrls: string[];
  // API need to attach, as api doesn't return it
  hasCoupon: boolean;
  coupons: PoiCoupon[];
  userRating: UserRating;
  couponRequested: boolean;
  unlockCount: number;
  unlockedByUser: boolean;
  lastWatering: LastWatering;
  plantDetail?: PlantDetail;
  wateredByDifferentUsersCount: number;
}

export interface PoiRating {
  id: number;
  review: string;
  rating: number;
  createdDate: string;
  user: {
    nickname: string;
  };
  poiId: number;
}

export interface RatingsResponse {
  items: PoiRating[];
}
